import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { AuthenticatedRequestError } from 'components/discovery/shared/ecommerce-api-token/api/authenticated-request.js'

export const ADD_TO_ORDER_TEMPLATES_API = Symbol('ADD_TO_ORDER_TEMPLATES_API')

export type AddProductToTemplateResponse = {
  success: boolean
}

export type RemoveProductFromTemplateResponse = {
  success: boolean
}

export interface AddToOrderTemplatesApi {
  addProductToTemplate(request: AddProductToTemplateRequest): Promise<AddProductToTemplateResponse>
  removeProductFromTemplate(request: RemoveProductFromTemplateRequest): Promise<RemoveProductFromTemplateResponse>
}

export class AddProductToTemplateRequest {
  endpoint: string
  token: string
  templateId: number
  payload: {
    product_id: number
    quantity: number
  }

  constructor(endpoint: string, token: string, templateId: number, productId: number, quantity: number) {
    this.endpoint = endpoint
    this.token = token
    this.templateId = templateId
    this.payload = { product_id: productId, quantity }
  }
}

export class RemoveProductFromTemplateRequest {
  endpoint: string
  token: string
  templateId: number
  productId: number

  constructor(endpoint: string, token: string, templateId: number, productId: number) {
    this.endpoint = endpoint
    this.token = token
    this.templateId = templateId
    this.productId = productId
  }
}

@registerDependency(FAKE, ADD_TO_ORDER_TEMPLATES_API)
export class FakeAddToOrderTemplatesApi implements AddToOrderTemplatesApi {
  addRequests: AddProductToTemplateRequest[] = []
  removeRequests: RemoveProductFromTemplateRequest[] = []
  addResponse: AddProductToTemplateResponse = { success: true }
  removeResponse: RemoveProductFromTemplateResponse = { success: true }
  throws: Error | null = null

  async addProductToTemplate(request: AddProductToTemplateRequest): Promise<AddProductToTemplateResponse> {
    this.addRequests.push(request)
    if (this.throws) throw this.throws
    return this.addResponse
  }

  async removeProductFromTemplate(request: RemoveProductFromTemplateRequest): Promise<RemoveProductFromTemplateResponse> {
    this.removeRequests.push(request)
    if (this.throws) throw this.throws
    return this.removeResponse
  }
}

@registerDependency(REAL, ADD_TO_ORDER_TEMPLATES_API)
export class RealAddToOrderTemplatesApi implements AddToOrderTemplatesApi {
  async addProductToTemplate(request: AddProductToTemplateRequest): Promise<AddProductToTemplateResponse> {
    const response = await fetch(new URL(`${request.templateId}/item/`, request.endpoint), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${request.token}` },
      body: JSON.stringify(request.payload),
    })
    if (!response.ok) throw new AuthenticatedRequestError(response.status, request.endpoint)
    return await response.json()
  }

  async removeProductFromTemplate(request: RemoveProductFromTemplateRequest): Promise<RemoveProductFromTemplateResponse> {
    const response = await fetch(new URL(`${request.templateId}/item/${request.productId}`, request.endpoint), {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${request.token}` },
    })
    if (!response.ok) throw new AuthenticatedRequestError(response.status, request.endpoint)
    return await response.json()
  }
}
